<template>
  <div>
    <normal-search
      :advanceSearch.sync="advanceSearch"
      :serverParams="serverParams"
      :searchTypes="searchTypes"
      :options="options"
      @submit="searchOrder()"
      @toggle="productionToggle()"
    />

    <advance-search
      :advanceSearch.sync="advanceSearch"
      :serverParams="serverParams"
      :searchTypes="searchTypes"
      :options="options"
      @submit="searchOrder()"
      @toggle="productionToggle()"
    />

    <div class="alert alert-danger w-100" v-if="error">{{ error }}</div>

    <div class="grid bg-white">
      <div class="grid-title">
        <h4>
          {{ title }} &nbsp;<span class="badge badge-info">{{
            total_records
          }}</span>
        </h4>
        <div
          v-if="statusKey == 'urgent' && urgentReason == 'fast_track'"
          class="pull-right"
        >
          <button
            class="btn btn-primary"
            :class="{ disabled: loading }"
            @click="showFastTrackModal()"
          >
            Modify Fast Track Availability in the Frontend
          </button>
        </div>
      </div>
      <div class="grid-body">
        <div class="row">
          <div class="col-md-2">
            <div class="form-group">
              <label for="">Limit</label>
              <select
                class="form-control"
                v-model="serverParams.perPage"
                @change="onchangeLimit()"
              >
                <option>10</option>
                <option>20</option>
                <option>50</option>
                <option>200</option>
                <option>500</option>
                <option>All</option>
              </select>
            </div>
          </div>
          <div class="col-md-1">
          </div>
          <div class="col-md-3 text-center" v-if="showFastTrackInfo">
            <label for="">Current status</label>
            <strong class="fast_track_info">{{ fastTrackCurrentStatus }}</strong>
          </div>
          <div class="col-md-3 text-center" v-if="showFastTrackInfo">
            <label for="">Fast Track is available until</label>
            <strong class="fast_track_info">{{ formattedFastTrackDate }}</strong>
            <p>
              *Please note, the date is in the German Timezone.
            </p>
          </div>
          <div class="col-md-3 text-center" v-if="showFastTrackInfo">
            <label for="">Num of Fast Track Orders Left</label>
            <strong class="fast_track_info">
                {{ fastTrackData.orders_until_disabled ? fastTrackData.orders_until_disabled : '-' }}
            </strong>
          </div>
        </div>
        <div class="table-responsive">
          <vue-good-table
            :columns="columns"
            mode="remote"
            @on-sort-change="onSortChange"
            styleClass="table table-orders table-bordered"
            :rows="orders"
            :line-numbers="true"
            @on-selected-rows-change="onSelectHandler"
            :selectOptions="{ enabled: true, selectOnCheckboxOnly: true }"
          >
            <template slot="table-row" slot-scope="props">
              <!-- shirt order number -->
              <span v-if="props.column.field === 'id'">
                <router-link
                  :to="{ path: '/shirt/detail/' + props.row.id }"
                  class="text-bold"
                >
                  {{ ezy.formatShirtId(props.row) }}
                </router-link>
              </span>

              <!-- Fabric ID -->
              <span v-else-if="props.column.field == 'fabric_id'">
                <router-link
                  :to="{
                    path:
                      '/fabric/update/' +
                      getFullFabricCode(props.row.fabric_id.toString()),
                  }"
                  class="text-bold"
                >
                  {{ props.row.fabric_id }}
                </router-link>
              </span>

              <!-- status -->
              <span v-else-if="props.column.field == 'shirt_order_status_id'">
                {{ props.row.shirt_order_status.title }}
              </span>

              <!-- waiting info -->
              <span v-else-if="props.column.field == 'waiting_reason'">
                <span
                  class="badge badge-danger pointer"
                  v-if="props.row.waiting_reason"
                  @click="alertWaitingNotes(props.row.waiting_notes)"
                >
                  {{ props.row.waiting_reason }}
                </span>
              </span>

              <!-- urgent Comment -->
              <span v-else-if="props.column.field == 'urgent_comment'">
                <span
                  class="btn btn-warning btn-sm pointer"
                  @click="showCommentBox(props.row.originalIndex)"
                >
                  Comments &nbsp;
                  <span
                    class="badge badge-info"
                    v-if="countComments(props.row.comments) > 0"
                  >
                    {{ countComments(props.row.comments) }}
                  </span>
                </span>
              </span>

              <!-- Documents Print -->
              <span v-else-if="props.column.field == 'documents'">
                <print-documents
                  :shirt="props.row"
                  @click="printProductionSheet"
                  :showPatternPrintingButtonOnTheTableList="
                    statusKey != 'new_order'
                  "
                />
              </span>

              <span v-else-if="props.column.field == 'created_at'">
                {{ ezy.tzDate(props.row.original_created_at, props.row.timezone) }} ({{ props.row.country }})
              </span>

              <span v-else-if="props.column.field == 'urgent_date_added'">
                {{ ezy.date(props.row.urgent_date_added) }}
              </span>

              <!-- others columns -->
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>

            <!-- action button for select rows -->
            <div slot="selected-row-actions">
              <button
                v-if="isRowSelectionHasProductionSheet"
                class="btn btn-primary btn-sm"
                @click="multiplePrintProductionSheet()"
              >
                <i class="fa fa-print" aria-hidden="true"></i> Production Sheet
              </button>
              <button
                v-if="isRowSelectionHasPattern"
                class="btn btn-success btn-sm"
                @click="multiplePrintPattern()"
              >
                <i class="fa fa-print" aria-hidden="true"></i> Pattern
              </button>
              <multiple-action-button
                :data="rowSelection"
                @success="getOrders()"
              />
            </div>
          </vue-good-table>
        </div>

        <!-- loading icon -->
        <div class="row" v-if="loading">
          <div class="col-md-12 text-center">
            <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </div>

    <comment-modal @submit="setComment" :order="selectedOrder" />
    <fast-track-modal
      v-if="showFastTrackInfo"
      :orders_until_disabled="fastTrackData.orders_until_disabled"
      :date_until_disabled="fastTrackData.date_until_disabled"
      :record_updated="fastTrackData.record_updated"
      :loading="loading"
      @submit="saveFastTrack"
    />
  </div>
</template>

<script>
import printCollector from "../tools/PrintCollector";
import AdvanceSearch from "../components/AdvanceSearch";
import NormalSearch from "../components/NormalSearch";
import PrintDocuments from "../components/PrintDocuments";
import MultipleActionButton from "../components/MultipleActionButton";
import statusIdToStatus from "@/pages/Tools/statusIdToStatus";
import { VueGoodTable } from "vue-good-table";
import CommentModal from "../components/CommentModal";
import FastTrackModal from "../components/FastTrackModal";
import {
  doesShirtOrderStatusNeedChangingDueToPatternPrinting,
  doesShirtOrderStatusNeedChangingDueToProductionSheetPrinting,
} from "../tools/ShirtOrderStatus";

export default {
  props: ["columns", "statusKey", "waitingReason", "urgentReason"],
  components: {
    VueGoodTable,
    PrintDocuments,
    MultipleActionButton,
    AdvanceSearch,
    NormalSearch,
    CommentModal,
    FastTrackModal,
  },
  data() {
    return {
      selectedOrder: {}, //for comment box
      box_colors: [
        { value: null, title: "Select Color" },
        { value: "red", title: "red" },
        { value: "green", title: "green" },
        { value: "blue", title: "blue" },
        { value: "orange", title: "orange" },
        { value: "black", title: "black" },
        { value: "pink", title: "pink" },
        { value: "yellow", title: "yellow" },
      ],
      orders: [],
      title: "",
      total_records: 0,
      rowSelection: [],
      serverParams: {
        productionOnly: true,
        columnFilters: [],
        sort: [
          { field: "created_at", type: "asc" },
          { field: "id", type: "desc" },
        ],
        page: 1,
        perPage: 200,
        searchType: "id",
        option: "=",
        keywords: [],
      },
      canScroll: false,
      status: "",
      loading: false,
      searchTypes: [
        { column: "id", title: "Order Number", option: "=", keyword: null },
        { column: "fabric_id", title: "Fabric", option: "=", keyword: null },
        {
          column: "collar_fabric_id",
          title: "C & C Outside",
          option: "=",
          keyword: null,
        },
        {
          column: "inner_collar_fabric_id",
          title: "Contrast",
          option: "=",
          keyword: null,
        },
        { column: "age", title: "Age", option: "=", keyword: null },
        {
          column: "days_in_current_step",
          title: "Days In Current Step",
          option: "=",
          keyword: null,
        },
        {
          column: "shirt_order_status_id",
          title: "Status",
          option: "=",
          keyword: null,
        },
      ],
      options: [
        { value: "=", name: "EQUAL TO" },
        { value: "!=", name: "NOT EQUAL TO" },
        { value: ">", name: "GREATER THAN" },
        { value: "<", name: "LESS THAN" },
      ],
      error: null,
      advanceSearch: false,
      shirtOrderStatuses: [],
      filteredResults: false,
      isReadOnlyUser: false,
      fastTrackData: {
        orders_until_disabled: null,
        date_until_disabled: null,
        record_updated: null,
      }
    };
  },
  computed: {
    isRowSelectionHasProductionSheet() {
      return this.rowSelection.some((shirt) => {
        return !(shirt.type === "lady" && !shirt.lady_size_loaded);
      });
    },
    isRowSelectionHasPattern() {
      return this.rowSelection.some((shirt) => {
        return !(shirt.type === "lady" && !shirt.pattern_url);
      });
    },
    showFastTrackInfo() {
      return (this.statusKey == 'urgent' && this.urgentReason == 'fast_track');
    },
    formattedFastTrackDate() {
      let date = moment(this.fastTrackData.date_until_disabled);
      return date.isValid() ? date.format('D MMM YYYY') : '-';
    },
    fastTrackCurrentStatus() {
      const remainingFastTrackOrder = this.fastTrackData.orders_until_disabled
      const fastTrackExpirationDate = moment(this.fastTrackData.date_until_disabled);
      const currentDate = moment();

      return (remainingFastTrackOrder > 0 && fastTrackExpirationDate.isAfter(currentDate)) ? 'Available' : 'Unavailable'
    }
  },
  async mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    this.shirtOrderStatuses = await statusIdToStatus.getStatuses();
    this.getStatus();
    this.scroll();
    await this.getOrders();
    if (this.status === "urgent") {
      this.applyDefaultSorting(this.orders);
    }
  },

  watch: {
    statusKey: function () {
      this.reloadPageData();
    },
    waitingReason: function () {
      this.reloadPageData();
    },
    urgentReason: function () {
      this.reloadPageData();
    },
  },
  methods: {
    /**
     * This function is to reset all the filters
     */
    reloadPageData() {
      (this.serverParams.columnFilters = []),
        (this.serverParams.sort = [
          { field: "created_at", type: "asc" },
          { field: "id", type: "desc" },
        ]);
      this.serverParams.page = 1;
      this.serverParams.perPage = 200;
      this.serverParams.productionOnly = true;
      this.serverParams.keywords = [];
      this.serverParams.searchType = "id";
      this.getStatus();
      this.getOrders();
    },

    /**
     * This function is to show the fast track modal
     */
    showFastTrackModal() {
      if (!this.isReadOnlyUser) {
        show_modal("#fast-track-modal");
      } else {
        toastr.error(
          "Not authorized, please ensure that you have the required permissions."
        );
      }
    },

    /**
     * This function is to save the fast track details
     * to the database
     */
    async saveFastTrack(params) {
      try {
        this.loading = true;
        await axios.post("shirt_orders/update_fast_track_availability", {
          date_available_until: moment(params.dateAvailableUntil).format(
            "YYYY-MM-DD HH:mm:00"
          ),
          number_of_orders_available: params.numberOfOrdersAvailable,
        });
        await this.getOrders();
        this.loading = false;
        hide_modal("#fast-track-modal");
        toastr.success("Fast Track Availability has been updated");
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error("There was an issue updating Fast Track Availability");
        }
      }
    },

    /**
     * This function is to show comment box
     * @param {number} index
     */
    showCommentBox(index) {
      if (!this.isReadOnlyUser) {
        this.selectedOrder = this.orders[index];
        this.selectedOrder["originalIndex"] = index;
        show_modal("#comment-modal");
      } else {
        toastr.error(
          "Not authorized, please ensure that you have the required permissions."
        );
      }
    },

    /**
     * This function is to count number of comments
     * @param {Array} comments
     * @return {number}
     */
    countComments(comments) {
      if (comments) {
        let total = comments.filter((comment) => comment.text);
        return total.length;
      }
      return 0;
    },

    /**
     * This function is to set comment message in specific the shirt order
     * @param {object} param
     */
    setComment(param) {
      this.orders[param.index].comments = param.comments;
    },

    /**
     * This function is to reload data,
     * After limit per rows for shirt orders was changed.
     */
    onchangeLimit() {
      this.serverParams.page = 1;
      this.canScroll = true;
      this.orders = [];
      this.getOrders();
    },

    keywordToStatusId(statusKeyword) {
      let index = _.findIndex(this.shirtOrderStatuses, {
        keyword: statusKeyword,
      });
      if (index != -1) {
        return this.shirtOrderStatuses[index].id;
      }
      return -1;
    },

    titleToStatusId(statusLabel = "") {
      let index = _.findIndex(this.shirtOrderStatuses, { label: statusLabel });
      if (index != -1) {
        return this.shirtOrderStatuses[index].id;
      }
      return -1;
    },

    getStatus() {
      let statusId = this.keywordToStatusId(this.statusKey);
      this.status = statusId < 0 ? this.statusKey : statusId;
      let index = _.findIndex(this.shirtOrderStatuses, { id: this.status });
      if (index != -1) {
        this.title = this.shirtOrderStatuses[index].label;
      } else {
        this.title = this.statusKey;
      }
    },

    /**
     * This function is to lode more data when scroll
     */
    scroll() {
      window.onscroll = () => {
        var elem = document.getElementsByClassName("page-content")[0];
        if (this.canScroll == true) {
          this.loading = true;
          if (
            document.documentElement.scrollTop +
              document.documentElement.offsetHeight >=
            elem.scrollHeight
          ) {
            this.getOrders((scroll = true));
          }
        }
      };
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    /**
     * This function is to reload shirt orders
     * After sorting for shirt orders was changed
     * @param {any} params
     */
    onSortChange(params) {
      this.updateParams({
        sort: params,
        page: 1,
      });
      this.getOrders();
    },

    /**
     * This function is to filter shirt orders with selected parameter
     */
    searchOrder() {
      let param = {
        columnFilters: [],
        page: 1,
      };
      param.columnFilters = [
        {
          column: this.serverParams.searchType,
          option: this.serverParams.option,
          keyword: this.serverParams.keywords,
        },
      ];
      if (this.advanceSearch) {
        param.columnFilters = this.searchTypes;
      }
      this.updateParams(param);
      this.getOrders();
      this.filteredResults = true;
    },

    /**
     * This function is to get full fabric Code ( FabricId ) of shirt order
     * @param {string} fabricShortCode
     */
    getFullFabricCode(fabricShortCode = "") {
      let fullFabricCode = "";
      fabricShortCode.toLowerCase().includes("k")
        ? (fullFabricCode = parseInt(fabricShortCode.slice(1)) + 30000)
        : fabricShortCode.toLowerCase().includes("t")
        ? (fullFabricCode = parseInt(fabricShortCode.slice(1)) + 20000)
        : (fullFabricCode = parseInt(fabricShortCode) + 10000);

      return JSON.stringify(fullFabricCode);
    },

    /**
     * This function is to sort shirt orders base on production step
     * @param {Array<object>} data
     * @return {Array<object>}
     */
    sortAccordingToProduction(data) {
      const prodSteps = [
        "New Orders",
        "Collector Printed",
        "Document Printed",
        "Cutting Preparation",
        "C and C Cutting",
        "Cutting",
        "Fusing and Embroidery",
        "Stitching 1",
        "Stitching 2",
        "Buttons",
        "QC",
        "Packaging",
        "Shelf",
      ];

      return data.sort(
        (a, b) =>
          prodSteps.indexOf(a.shirt_order_status.title) -
          prodSteps.indexOf(b.shirt_order_status.title)
      );
    },

    processServerParams(serverParams) {
      return {
        ...serverParams,
        columnFilters: serverParams.columnFilters.map((columnFilter) => {
          // Replace status keywords with IDs
          if (
            columnFilter.column === "shirt_order_status_id" &&
            columnFilter.keyword
          ) {
            return {
              ...columnFilter,
              keyword: columnFilter.keyword.map(this.titleToStatusId),
            };
          }

          return columnFilter;
        }),
      };
    },

    /**
     * This function is to get the shirt order list
     * @param {boolean|null} scroll
     */
    async getOrders(scroll = false) {
      this.loading = true;
      if (scroll === false) {
        this.orders = [];
      }

      // Prevent the url to contain a trailing /, in which case the api may return a 301 response
      let url = `shirt_orders/listings/${this.status}`.replace(/\/$/, "");

      if (this.status === "waiting") {
        url = url + "/" + this.waitingReason;
      }

      if (this.status === "urgent") {
        url = url + "/" + this.urgentReason;
      }

      try {
        let serverParams = this.serverParams;
        let res = await axios.post(url, {
          serverParams: this.processServerParams(serverParams),
        });
        let data = this.filteredResults
          ? this.sortAccordingToProduction(res.data.data)
          : res.data.data;
        this.total_records = res.data.pagination.total_records;

        if (this.status == "urgent" && this.urgentReason == "fast_track") {
          if (res.data.fast_track_data.status) {
            this.fastTrackData.record_updated =
              res.data.fast_track_data.record_updated;
            this.fastTrackData.date_until_disabled =
              res.data.fast_track_data.result.date_until_disabled;
            this.fastTrackData.orders_until_disabled =
              res.data.fast_track_data.result.orders_until_disabled;
          }
        }

        data.forEach((val) => {
          val.fabric_id = val.fabric_id == 0 ? "" : val.fabric_id;
          val.collar_fabric_id =
            val.collar_fabric_id == 0 ? "" : val.collar_fabric_id;
          val.inner_collar_fabric_id =
            val.inner_collar_fabric_id == 0 ? "" : val.inner_collar_fabric_id;
          this.orders.push(val);
        });
        if (
          data.length < this.serverParams.perPage ||
          this.serverParams.perPage === "All"
        ) {
          this.canScroll = false;
        } else {
          this.canScroll = true;
          this.serverParams.page++;
        }
        this.filteredResults = false;
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        }
      }
      this.loading = false;
    },

    /**
     * This function is to show alert box for waiting notes
     * @param {string} text
     */
    alertWaitingNotes(text) {
      Swal.fire(text, "", "info");
    },

    /**
     * This function is to set selectedRows
     * @param {any} params
     */
    onSelectHandler(params) {
      this.rowSelection = params.selectedRows;
    },

    /**
     * This function is to print multiple production.
     *
     * Max selected rows should be 200.
     * If one of selected rows does not allowed to print production sheet, will skip for that one.
     * In the end, it will change shirt order status and print products sheet for all the selected rows.
     */
    async multiplePrintProductionSheet() {
      let limit = 200;
      if (this.rowSelection.length > limit) {
        return (this.error = "Selected Items are More Than " + limit);
      }
      let params = [];
      this.rowSelection.forEach((shirt) => {
        /**
         * If shirt type is lady and lady_size_loaded is false,
         * Do not allow to print production sheet
         */
        if (shirt.type === "lady" && !shirt.lady_size_loaded) return false;

        // Get changed shirt order status
        let changeShirtOrderStatus = doesShirtOrderStatusNeedChangingDueToProductionSheetPrinting(
          shirtOrderStatus,
          shirt.production_docs_ready,
          shirt.shirt_order_status.id
        );

        params.push({ id: shirt.id, changeShirtOrderStatus });
      });
      this.printProductionSheet(params);
      this.rowSelection = [];
    },

    /**
     * This function is to print multiple pattern.
     *
     * Max selected rows should be 20.
     * If one of selected rows does not allowed to print pattern, will skip for that one.
     * In the end, it will change shirt order status and print pattern for all the selected rows.
     */
    async multiplePrintPattern() {
      let limit = 20;
      if (this.rowSelection.length > limit) {
        return (this.error = "Selected Items are More Than " + limit);
      }
      let params = [];
      this.rowSelection.forEach((shirt) => {
        /**
         * If shirt type is lady and pattern_url is false,
         * Do not allow to print pattern
         */
        if (shirt.type === "lady" && !shirt.pattern_url) return false;

        // Get changed shirt order status
        let changeShirtOrderStatus = doesShirtOrderStatusNeedChangingDueToPatternPrinting(
          shirtOrderStatus,
          shirt.production_docs_ready,
          shirt.shirt_order_status.id
        );

        params.push({ id: shirt.id, changeShirtOrderStatus });
      });
      this.printPattern(params);
      this.rowSelection = [];
    },

    /**
     * This function is to print pattern for shirt orders
     * And update shirt order status id to PATTERN_PRINTED
     *
     * @param {Array} shirtOrders
     */
    async printPattern(shirtOrders) {
      let url = "/pattern/" + JSON.stringify(shirtOrders);
      await ezy.openPDFInNewWindow(url);

      let shirtOrderIds = shirtOrders.map((shirtOrder) => shirtOrder.id);

      this.orders = this.orders.map((order) => {
        if (shirtOrderIds.includes(order.id)) {
          order.shirt_order_status.id = shirtOrderStatus.PATTERN_PRINTED;
        }
        return order;
      });
    },

    /**
     * This function is to print production sheet for shirt orders
     * @param {Array} params
     */
    printProductionSheet(params) {
      let self = this;
      printCollector(params, function (res) {
        if (res) {
          self.updateParams({
            page: 1,
          });
        }
      });
    },

    /**
     * This function is to filter shirt order list
     * Whether show all shirt or production shirt only
     */
    productionToggle() {
      this.serverParams.page = 1;
      this.getOrders();
      if (this.status === "urgent") {
        this.applyDefaultSorting(this.orders);
      }
    },

    /**
     * Default sorting for Urgent shirt orders.
     * @param {Array} orders
     */
    applyDefaultSorting(orders) {
      const statusesOrder = [
        0, //NEW_ORDER
        100, //COLLECTOR_PRINTED
        101, //PATTERN_PRINTED
        50, // DOCUMENT_PRINTED
        58, //CUTTING_PREPARATION
        59, //C_AND_C_CUTTING
        102, //CUTTING
        51, //WAITING_FOR_EMB
        53, //FUSING_AND_EMB
        103, //STITCHING_1
        60, //STITCHING_2
        54, //BUTTONS
        56, //WAITING_FOR_BUTTON
        55, //WAITING_FOR_BUTTON_2
        104, //BUTTON_HOLE
        105, //QC_1
        106, //PACKAGING
        107, //SHELF
        57, //QC_2
      ];

      orders.sort(function (a, b) {
        // Sort by Production Step
        const indexOfStatusA = statusesOrder.indexOf(a.shirt_order_status.id);
        const indexOfStatusB = statusesOrder.indexOf(b.shirt_order_status.id);
        if (indexOfStatusA < indexOfStatusB) {
          return -1;
        } else if (indexOfStatusA > indexOfStatusB) {
          return 1;
        } else {
          // Sort by age
          if (a.age < b.age) {
            return -1;
          } else if (a.age > b.age) {
            return 1;
          } else {
            // Sort by Order number
            if (a.id < b.id) {
              return -1;
            } else if (a.id > b.id) {
              return 1;
            } else {
              return 0;
            }
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.fa-spin {
  font-size: 40px;
}
.search-type {
  height: 38px !important;
}
.w-100 {
  width: 100% !important;
}
.table-orders select {
  text-transform: uppercase;
  font-size: 11px;
  font-weight: bold;
  height: 30px !important;
}
.fast_track_info {
  margin-top: 10px;
  color: #5e72e4;
  display: block;
  font-size: 20px;
}
</style>
